const RELOADED_AT_KEY = '@Habitar:reloaded-for-update-at'
const LEGACY_RELOADED_KEY = '@Habitar:reloaded-for-update'

export const RELOAD_COOLDOWN_MS = 60_000

const CHUNK_LOAD_ERRORS = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'is not a valid JavaScript MIME type',
  'Unable to preload CSS'
]

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return CHUNK_LOAD_ERRORS.some(pattern => message.includes(pattern))
}

export function canReloadForUpdate(lastReloadAt: number | null, now: number): boolean {
  return lastReloadAt === null || Math.abs(now - lastReloadAt) >= RELOAD_COOLDOWN_MS
}

export function parseReloadedAt(value: string | null): number | null {
  const timestamp = Number(value)
  return value && Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null
}

export function reloadForUpdate(): boolean {
  try {
    const now = Date.now()
    if (!canReloadForUpdate(parseReloadedAt(sessionStorage.getItem(RELOADED_AT_KEY)), now)) return false
    sessionStorage.setItem(RELOADED_AT_KEY, String(now))
    sessionStorage.removeItem(LEGACY_RELOADED_KEY)
  } catch {
    return false
  }
  location.reload()
  return true
}
